<script setup lang="ts">
const { emitInterfaceEvent } = useEvents()
const scrollToBottom = () => {
  emitInterfaceEvent("scrollToLatestAgentMessage", {})
}
</script>

<template>
  <div class="toast" @click="scrollToBottom">
    <div class="icon">
      <icon-action type="arrow-down" size="2xs" />
    </div>
    <div>
      Go to latest message
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.toast
  @apply bg-[#{$toast-bg-default}] h-6 px-2.5 rounded-full
  @apply inline-flex items-center gap-1.5
  @apply t-menu-xs text-ellipses-inline
  @apply backdrop-blur-$menu-blur-default backdrop-filter
  @apply cursor-pointer
  &:hover
    @apply bg-$global-violet-accent

.icon
  @apply flex items-center justify-center
</style>
